import ChatEntry from '../dto/ChatEntry.js';
import Error from '../model/Error.js';
import axios from 'axios';

export default class ChatRepository {

    static findAll(institutionKey, institutionId, search) {
        return new Promise((resolve, reject) => {
            let params = {};
            if (search !== null && search !== '') {
                params.search = search;
            }

            let apiUrlPrefix = '';
            switch (institutionKey) {
                case 'club':
                    apiUrlPrefix = '/club/clubs';
                    break;
                case 'kindergarten':
                    apiUrlPrefix = '/kindergartens';
                    break;
                default:
                    throw new Error(`Invalid institution key: ${institutionKey}`);
            }

            axios
                .get(`${apiUrlPrefix}/${institutionId}/chats`, { params })
                .then(response => resolve(response.data.data.map(data => ChatEntry.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static createForKindergartenAndChildAndUsers(kindergartenId, childIds, userIds, title) {
        const data = {childIds: childIds, userIds: userIds, title: title};
        return new Promise((resolve, reject) => {
            axios
                .post(`/kindergartens/${kindergartenId}/chats`, data)
                .then(response => resolve(response))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(chatId, title) {
        const data = {title: title};
        return new Promise((resolve, reject) => {
            axios
                .put(`/chat/${chatId}`, data)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static terminate(chatId) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`/chat/${chatId}`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(chatId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/chat/${chatId}`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
